exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter {\n  opacity: 0.01; }\n\n.fade-enter-active {\n  opacity: 1;\n  transition: opacity 200ms linear; }\n\n.fade-exit {\n  opacity: 1; }\n\n.fade-exit-active {\n  opacity: 0.01;\n  transition: opacity 200ms linear; }\n", ""]);

// exports
